import SiteLayout from "@/components/feature/SiteLayout";
import { useSEO } from "@/hooks/useSEO";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import LatestNews from "./components/LatestNews";
import HotRecommend from "./components/HotRecommend";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  useSEO({
    title: "明明不喜欢—最新影视资讯与剧情介绍",
    description:
      "明明不喜欢为您提供最新的影视资讯、剧情介绍及相关影视作品信息，涵盖电影和电视剧，方便用户了解和查找影视内容。",
    keywords:
      "明明不喜欢,影视资讯,剧情介绍,电影推荐,电视剧,影视作品,影视信息,最新影视",
  });

  return (
    <SiteLayout>
      <HeroCarousel />
      <CategoryEntries />
      <LatestNews />
      <HotRecommend />
      <SiteIntro />
    </SiteLayout>
  );
}